<template>
  <v-dialog v-model="show" max-width="440">
    <v-card v-if="promotion">
      <v-card-title class="d-flex align-center justify-space-between">
        <span>{{ promotion.name }}</span>
        <v-chip small :color="statusMeta.color" text-color="white">
          {{ statusMeta.labelKey ? $t(statusMeta.labelKey) : "" }}
        </v-chip>
      </v-card-title>
      <v-divider />
      <v-card-text class="pt-4">
        <div class="detail-row">
          <span>{{ $t("finance_period_label") }}</span>
          <strong>{{ formatDate(promotion.periodStart) }} - {{ formatDate(promotion.periodEnd) }}</strong>
        </div>
        <div class="detail-row">
          <span>{{ $t("finance_discount") }}</span>
          <strong>{{ promotion.discount }}</strong>
        </div>
        <div class="detail-row">
          <span>{{ $t("finance_funded_by") }}</span>
          <strong>{{ $t(PROMOTION_FUNDING_META[promotion.fundedBy]) }}</strong>
        </div>

        <v-divider class="my-3" />

        <div class="detail-row">
          <span>{{ $t("finance_ordera_share") }}</span>
          <strong>{{ promotion.orderaShare }}%</strong>
        </div>
        <div class="detail-row">
          <span>{{ $t("finance_restaurant_share") }}</span>
          <strong>{{ promotion.restaurantShare }}%</strong>
        </div>

        <v-divider class="my-3" />

        <div class="detail-row">
          <span>{{ $t("finance_order_count") }}</span>
          <strong>{{ promotion.orderCount }}</strong>
        </div>
        <div class="detail-row">
          <span>{{ $t("finance_new_sales") }}</span>
          <strong class="success--text">{{ formatCurrency(promotion.newSales, restaurantCurrency) }}</strong>
        </div>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-btn text color="error" @click="$emit('delete', promotion)">{{ $t("finance_delete") }}</v-btn>
        <v-spacer />
        <v-btn text @click="$emit('edit', promotion)">{{ $t("finance_edit") }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { PROMOTION_STATUS_META, PROMOTION_FUNDING_META, formatDate, formatCurrency } from "../constants";

export default {
  name: "PromotionDetailDialog",

  props: {
    value: { type: Boolean, default: false },
    promotion: { type: Object, default: null },
  },

  data() {
    return { PROMOTION_FUNDING_META };
  },

  computed: {
    show: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    statusMeta() {
      return (
        (this.promotion && PROMOTION_STATUS_META[this.promotion.status]) || {
          labelKey: "",
          color: "grey",
        }
      );
    },
  },

  methods: { formatDate, formatCurrency },
};
</script>

<style scoped>
.detail-row {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  font-size: 0.9rem;
  color: rgba(0, 0, 0, 0.6);
  padding: 4px 0;
}

.detail-row strong {
  color: rgba(0, 0, 0, 0.87);
  text-align: right;
}
</style>
